<script setup lang="ts">
import { PageMeta } from '@/@vxapp/@Enums/PageMeta'
import SetPasswordForm from '@/components/Auth/SetPasswordForm.vue'
import { useNoReferrerMeta } from '@/composables/useNoReferrerMeta'

definePage({
  meta: { ...PageMeta.Auth.setPassword.meta, pageTitle: PageMeta.Auth.setPassword.title },
})
useNoReferrerMeta()
</script>

<template>
  <SetPasswordForm />
</template>
